module.exports = __webpack_public_path__ + "static/images/saved-poi-bookmark-icon.363q8GK.svg";